import React from 'react';
import { isOneTrust } from './cmpFlag';
import { ConsentProvider } from '../contexts/ConsentContext';

// ConsentProvider must wrap the WHOLE app — above the mobile short-circuit and
// the loading state in App.js — so useConsent()/the privacy control work for
// mobile-web visitors and footer-less routes too (fixes the consent-bypass bug).
// Passthrough when the CMP flag is off, preserving current behavior exactly.
export function AppShell({ children }) {
  return isOneTrust() ? <ConsentProvider>{children}</ConsentProvider> : <>{children}</>;
}
